import { ApprovalState, ReportType } from '@fdm/api-client';
import { ReportFormPage } from '../../report-form-control.service';

export const AREA_LEAD_INSP_ENGINEER_POLICY = {
  [ReportType.AnomalyReport]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.EQUIPMENTS]: [
      // ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
  [ReportType.IntegrityDeficiency]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
  [ReportType.ReliabilityDeficiency]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
  [ReportType.IntegrityThreat]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
  [ReportType.ReliabilityThreat]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RIPTScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
  [ReportType.TaskDeferral]: {
    [ReportFormPage.NOTES_ATTACHMENTS]: [
      ApprovalState.Draft,
      ApprovalState.DraftedForReview,
      ApprovalState.SubmittedToOpsAdvisor,
      ApprovalState.PlanConfirmed,
      ApprovalState.PlanEndorsed,
      ApprovalState.PlanApproved,
      ApprovalState.RiskEvaluationScored,
      ApprovalState.ResolutionPlanCompleted,
      ApprovalState.ValidationAndVerificationCompleted,
    ],
    [ReportFormPage.GENERAL]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.FINDING_DESCRIPTION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.RISK_EVALUATION]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.APPROVAL_FLOW]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.ACTION_ITEM]: [
      ApprovalState.DraftedForReview,
    ],
    [ReportFormPage.AUDIT_HISTORY]: [
      ApprovalState.DraftedForReview,
    ],
  },
};